import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b95a144"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "display-body" }
const _hoisted_2 = { class: "picture" }
const _hoisted_3 = {
  key: 0,
  class: "name-title"
}
const _hoisted_4 = { class: "class-rank" }
const _hoisted_5 = { class: "class-rank-number" }
const _hoisted_6 = { class: "points" }
const _hoisted_7 = { class: "course-information" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "course-information-title" }, "Current Course information", -1))
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-label" }, "Course: ", -1))
const _hoisted_13 = { class: "field-value" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-label" }, "Start: ", -1))
const _hoisted_16 = { class: "field-value" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "Class: ", -1))
const _hoisted_20 = { class: "field-value" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "Grad: ", -1))
const _hoisted_23 = { class: "field-value" }
const _hoisted_24 = { class: "leader-board" }
const _hoisted_25 = ["className"]
const _hoisted_26 = { class: "item-rank" }
const _hoisted_27 = { class: "item-picture" }
const _hoisted_28 = { class: "student-name" }
const _hoisted_29 = { class: "student-points" }

import { Class } from '@/models/Class';
import { computed, PropType } from 'vue';
import { Course } from '../../models/Course';
import { User } from '../../models/User';
import { formatDate_DD_MMM_YYYY, ordinalSuffixOf } from '../../utils/utils';
import IconComponent from '../icon/IconComponent.vue';
import Icon from '../icon/Icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileDisplayComponent',
  props: {
  currentUser: {
    type: Object as PropType<User | null>
  },
  currentCourse: {
    type: Object as PropType<Course | null>
  },
  currentClass: {
    type: Object as PropType<Class | null>
  },
  currentInstructors: {
    type: Array as PropType<User[] | null>
  },
  currentStudents: {
    type: Array as PropType<User[] | null>
  }
},
  setup(__props) {

const props = __props



const studentList = computed(() => {
  if (!props.currentStudents || !props.currentUser) {
    return [];
  }
  return props.currentStudents
    .map((student) => {
      return {
        ...student
      };
    })
    .sort((a, b) => {
      const aPoints = a.score.sum() || 0;
      const bPoints = b.score.sum() || 0;
      return bPoints - aPoints;
    });
});

const currentStudentClassRank = computed(() => {
  if (!props.currentUser || !studentList.value) {
    return 0;
  }
  return (
    studentList.value.findIndex(
      (student) => student.uid === props.currentUser?.uid
    ) + 1
  );
});

const currentStudentPoints = computed(() => {
  if (!props.currentUser) {
    return 0;
  }
  return studentList.value
    .find((student) => student.uid === props.currentUser?.uid)
    ?.score.sum();
});

const currentClassStartDate = computed(() => {
  if (!props.currentClass) {
    return '';
  }
  return formatDate_DD_MMM_YYYY(props.currentClass.startDate as Date);
});

const currentClassEndDate = computed(() => {
  if (!props.currentClass) {
    return '';
  }
  return formatDate_DD_MMM_YYYY(props.currentClass.endDate as Date);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.currentUser?.firstName[0]) + " " + _toDisplayString(__props.currentUser?.lastName[0]), 1),
    (__props.currentUser)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_3, _toDisplayString(__props.currentUser.firstName) + " " + _toDisplayString(__props.currentUser.lastName), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(ordinalSuffixOf)(_unref(currentStudentClassRank))), 1),
      _createVNode(IconComponent, {
        icon: _unref(Icon).STAR
      }, null, 8, ["icon"]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(currentStudentPoints)) + " pts.", 1)
    ]),
    _createElementVNode("section", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", _hoisted_13, _toDisplayString(__props.currentCourse?.courseName), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(currentClassStartDate)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString(__props.currentClass?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(currentClassEndDate)), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_24, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studentList), (student, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: student.uid,
            className: `item ${student.uid}`
          }, [
            _createElementVNode("p", _hoisted_26, _toDisplayString(index + 1), 1),
            _createElementVNode("div", _hoisted_27, _toDisplayString(student.firstName[0].toUpperCase() +
              student.lastName[0].toUpperCase()), 1),
            _createElementVNode("p", _hoisted_28, _toDisplayString(student.firstName) + " " + _toDisplayString(student.lastName), 1),
            _createElementVNode("p", _hoisted_29, _toDisplayString(student.score.sum()), 1)
          ], 8, _hoisted_25))
        }), 128))
      ])
    ])
  ]))
}
}

})